module.exports = __webpack_public_path__ + "img/logo_sp.3a07e9bb.svg";